<template>
  <div class="warp">
    <div class="title">普通搜索</div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <!-- 任务ID -->
        <el-col :span="6" v-if="type === 'marking'">
          <el-form-item label="任务ID">
            <el-input v-model="form.id"></el-input>
          </el-form-item>
        </el-col>

        <!-- 是否加急 -->
        <el-col :span="6">
          <el-form-item label="优先级">
            <el-select v-model="form.urgent" placeholder="请选择">
              <el-option
                :label="item.value"
                :value="item.key"
                v-for="item in urgentList"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 发布任务的管理员ID -->
        <el-col :span="6">
          <el-form-item label="发布管理员ID">
            <el-input v-model="form.publisher_id"></el-input>
          </el-form-item>
        </el-col>

        <!-- 状态 -->
        <el-col :span="6" v-if="type !== 'marking'">
          <el-form-item label="状态">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option
                :label="item.value"
                :value="item.key"
                v-for="item in statusList"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-else>
          <el-form-item label="状态">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option label="进行中" :value="0"></el-option>
              <el-option label="完成" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="媒体类型">
            <el-select v-model="form.media_type" placeholder="请选择" :clearable="false">
              <el-option label="长视频" :value="0"></el-option>
              <el-option label="短视频" :value="1"></el-option>
              <!-- <el-option label="动画" :value="2"></el-option>
              <el-option label="漫画" :value="3"></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="type !== 'marking'">
          <el-form-item label="标题">
            <el-input v-model="form.title" placeholder="标题"></el-input>
          </el-form-item>
        </el-col>
        <!-- 对接人ID -->
        <el-col :span="6" v-if="type === 'marking'">
          <el-form-item label="对接人ID">
            <el-input v-model="form.workUserId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对接人用户名">
            <el-input v-model="form.work_username"></el-input>
          </el-form-item>
        </el-col>
        <template v-if="type !== 'marking'">
          <el-col :span="6">
            <el-form-item label="媒体ID">
              <el-input v-model="form.videoId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截止时间">
              <el-date-picker
                v-model="form.end_at"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </template>
        <el-col class="cols">
          <el-button type="primary" @click="submit(form)">提交</el-button>
          <el-button @click="resetData">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      form: {
        end_at: this.getLastMonthDate(),
        media_type: 0
      },
      // 是否加急
      urgentList: [
        { key: 2, value: "高" },
        { key: 1, value: "中" },
        { key: 0, value: "低" },
      ],
      // 状态
      statusList: [
        { key: 0, value: "创作中" },
        { key: 1, value: "审核中" },
        { key: 2, value: "审核通过" },
        { key: 3, value: "拒绝" },
      ],
    };
  },
  props: ["delUrl", "parentsList", "type"],
  methods: {
    // 获取前一个月的日期时间戳
    getLastMonthDate() {
      const now = new Date();
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      return lastMonth.getTime();
    },
    resetData() {
      this.form = {
        end_at: this.getLastMonthDate(),
        media_type: 0
      };
      this.$emit("resetData", {
        end_at: this.getLastMonthDate() / 1000,
        media_type: 0
      });
    },
    submit(data) {
      this.$emit("searchData", {
        ...data,
        end_at: data.end_at / 1000
      });
    },
  },
};
</script>

<style scoped lang="scss">
.warp ::v-deep .el-date-editor,
.warp ::v-deep .el-select {
  width: 100% !important;
}
.el-form-item {
  margin-bottom: 10px;
}
.title {
  width: 100%;
  border-bottom: 1px solid #ebeef5;
  padding: 0 0 10px 0;
  box-sizing: border-box;
  margin: 0 0 20px 0;
}
.cols {
  display: flex;
  flex-direction: row-reverse;
  margin: 0 20px 10px 0;
  .el-button {
    margin: 0 0 0 10px;
  }
}
</style> 